module.exports = __webpack_public_path__ + "img/p4-2-3.5e0fa224.png";